import React, { useEffect, useState } from "react";
import Main from "../../components/layout/Main";
import { Col, Row, Card, Tabs, Typography, Select } from "antd";
import useRequest from "../../hooks/useRequest";
import Users from "../../assets/images/dashbord-user.png";

import { Severty, ShowToast } from "../../helper/toast";
import { Line } from "react-chartjs-2";
import { Link } from "react-router-dom";
import LastProducts from "./_LastProducts";
import SectionWrapper from "../../components/SectionWrapper";
import lang from "../../helper/lang";
import LastAppointments from "./_LastAppointments";
import MasterFacilitatorList from "./MasterFacilitatorList";
import apiPath from "../../constants/apiPath";
import ExpiredSubscription from "./_ExpiredSubscription";
import { globalYears } from "../../helper/Var";
import MasterFacilitator from "../MasterFacilator";
import CertifiedPractitioner from "../CertifiedPractitioner";
import CertifiedPractitionerList from "./CertifiedPractitionersList";
import LastSurveyProducts from "./_LastSurveyProducts";
const { Title } = Typography;
const { TabPane } = Tabs;

const Home = () => {
  const { request } = useRequest();
  const [dashboard, setDashboard] = useState({});
  const [loading, setLoading] = useState(false);
  const [years, setYears] = useState();
  const [refresh, setRefresh] = useState();
  useEffect(() => {
    setLoading(true);
    fetchData();
  }, [refresh]);

  const count = [
    {
      title: lang("Total Surveys"),
      value: dashboard?.totalSurveys || 0,
      icon: Users,
      url: "/survey",
    },
    {
      title: lang("Total Reports"),
      value: dashboard?.totalReports || 0,
      icon: Users,
      url: "/survey",
    },
    {
      title: lang("Total Master Facilitators"),
      value: dashboard?.totalMf || 0,
      icon: Users,
      url: "/master-facilitator",
    },
    {
      title: lang("Total Certified Practitioners"),
      value: dashboard?.totalCp || 0,
      icon: Users,
      url: "/certified-practitioner",
    },
  ];

  const fetchData = () => {
    try {
      request({
        url: apiPath.dashboard,
        method: "GET",
        onSuccess: ({ data }) => {
          setLoading(false);
          console.log(data);
          setDashboard(data);
          // setLocation(data.data.data);
        },
        onError: (error) => {
          setLoading(false);
          ShowToast(error?.response?.data?.message || "Internal Server Error", Severty.ERROR);
        },
      });
    } catch (error) {
      setLoading(false);
      ShowToast(error?.response?.data?.message || "Internal Server Error", Severty.ERROR);
    }
  };

  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 16]}>
        {count.map((c, index) => {
          return (
            <Col
              key={index}
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={8}
              xxl={6}
              className="mb24"
              style={{ paddingRight: "0px" }}
            >
              <Link to={c.url}>
                <Card
                  bordered={false}
                  className="criclebox icon-box-text_mainhh"
                  style={{ height: "100%" }}
                >
                  <div className="number">
                    <div className="icon-box-text">
                      <span>{c?.title}</span>
                      <Title level={3}>{c?.value}</Title>
                    </div>
                    <div className="icon-box">
                      <img src={c?.icon} />
                    </div>
                  </div>
                </Card>
              </Link>
            </Col>
          );
        })}
      </Row>
      {/* <Card title={lang("Earning")} className="mt-3">
        <Row>
          <Col xs={24} xl={24} lg={24}>
            {/* <div className="role-wrap">
                <Select
                 
                  last20Years
                  width="110px"
                  placeholder={lang("Year")}
                  showSearch
                  value={years}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  options={globalYears.map((item) => ({
                    value: item.value,
                    label: item.label,
                  }))}
                  onChange={(value) => setYears(value)}
                />
              </div> */}
      {/* <Tabs className="main_tabs">
              <TabPane tab={lang("Week")} key="Week">
                <div style={{ padding: "25px" }}>
                  <Row gutter={[24, 0]}>
                    <WeeklyChartSection borderColor="#1EB564" />
                  </Row>
                </div>
              </TabPane>
              <TabPane tab={lang("Month")} key="Month">
                <div style={{ padding: "25px" }}>
                  <Row gutter={[24, 0]}>
                    <MonthlyChartSection borderColor="#1EB564" />
                  </Row>
                </div>
              </TabPane>

              <TabPane tab={lang("Year")} key="Year">
                <div style={{ padding: "25px" }}>
                  <Row gutter={[24, 0]}>
                    <YearlyChartSection borderColor="#1EB564" />
                  </Row>
                </div>
              </TabPane>
            </Tabs> */}
      {/* </Col> */}
      {/* </Row>
      </Card> */}

      <Card className="mt-4">
        <div>
          <div className="main-new-lat-10-biiking-header">
            <h4>{lang("Open and Closed Surveys  ")}</h4>
          </div>
          <LastSurveyProducts
            data={((dashboard?.recentSurveyList || []).concat(
              dashboard?.pastSurveyList || []
            )).slice(0, 10)}
            loading={loading}
          />
        </div>
      </Card>

      <Card className="mt-4">
        <div>
          <div className="main-new-lat-10-biiking-header">
            <h4>{lang("Reports")}</h4>
          </div>
          <LastProducts
            data={(dashboard?.reportList || []).slice(0, 10)}
            loading={loading}
            isShow={false}
          />
        </div>
      </Card>
      <Card className="mt-4">
        <div>
          <div className="main-new-lat-10-biiking-header">
            <h4>{lang("Master Facilitators")}</h4>
          </div>
          <MasterFacilitator dashbord={true} />
          {/* <MasterFacilitatorList
            data={dashboard?.mfWithMPs}
            loading={loading}
            refresh={() => setRefresh((f) => !f)}
          /> */}
        </div>
      </Card>

      <Card className="mt-4">
        <div>
          <div className="main-new-lat-10-biiking-header">
            <h4>{lang("Certified Practitioners")}</h4>
          </div>
          <CertifiedPractitioner dashbord={true} />
          {/* <CertifiedPractitionerList
            data={dashboard?.mfWithMPs}
            loading={loading}
            refresh={() => setRefresh((f) => !f)}
          /> */}
        </div>
      </Card>

      {/* <Col xs={24} xl={24} className="sm-padding-0 mt-3 ">
        <Card title={lang("Last 10 Transactions")}>
          <LastTransaction data={dashboard?.transactions} loading={loading} />
        </Card>
      </Col> */}
    </>
  );
};

export default Home;
